import React, { useEffect, useState } from 'react';
import './Homepage.css';
import HomePageCard from './HomePageCard';
import Loader from '../common/Loader';
import SearchComponent from '../Navbar/SearchBar';
import MobSearchComponent from '../SearchBar/SearchBarMob';
import MobileSearchBar from '../SearchBar/SearchBarMob';

function Homepage() {
    const [isBannerLoading, setIsBannerLoading] = useState(false);
    const [loading, setLoading] = useState(true);

    const handleBannerLoad = () => {
        setIsBannerLoading(true);
    };


    useEffect(() => {
        setTimeout(() => { setLoading(false) }, 800)
    })



    return (

        <>
            {loading ? (<Loader />) : (
                <div className='homepage-div'>
                    <MobileSearchBar margin={"20px 0 0 0"} />
                    <div className='banner-div'>
                        <img
                            className='desktop-banner'
                            style={{ display: isBannerLoading ? 'block' : 'none' }}
                            src='https://firebasestorage.googleapis.com/v0/b/jackpot-95e4b.appspot.com/o/banner%2FJackpot.png?alt=media&token=d4972037-5228-466a-b51c-eb3686f16623'
                            alt='Jackpot banner'
                            onLoad={handleBannerLoad}
                        />
                        <img
                            className='mobile-banner'
                            style={{ display: isBannerLoading ? 'block' : 'none' }}
                            src='https://firebasestorage.googleapis.com/v0/b/jackpot-95e4b.appspot.com/o/banner%2FJackpot%20-%20mobile.png?alt=media&token=1b19aae2-3da2-4cc1-a673-8c8748d1a856'
                            alt='Jackpot banner'
                            onLoad={handleBannerLoad}
                        />
                    </div>
                    <div className='category-cards'>
                        <div className='category-heading'>
                            <h4>CATEGORIES</h4>
                            <hr />
                        </div>
                        <div className='casuals-cards'>
                            <HomePageCard width='275px' category='CASUALS' type='All' path='/casuals/all' height='275px' img='https://d4kuloxg8pkbr.cloudfront.net/media/catalog/product/cache/5a1a0235936279cdcf9081753e3e3277/1/_/1_mfk-9401-q-02-white_1.jpg' />
                            <HomePageCard width='275px' category='CASUALS' type='Shirts' path='/casuals/shirts' height='275px' img='https://assets.myntassets.com/h_1440,q_100,w_1080/v1/assets/images/6712298/2019/3/6/886b9606-d633-4b2c-9bba-9a0fbb0f6ca61551858861314-Dennis-Lingo-Men-Red--Navy-Blue-Slim-Fit-Checked-Casual-Shir-1.jpg' />
                            <HomePageCard width='275px' category='CASUALS' type='T-Shirts' path='/casuals/tshirts' height='275px' img='https://getketchadmin.getketch.com/product/8905040213293/660/HLTS001422_1.JPG' />
                            <HomePageCard width='275px' category='CASUALS' type='Pants' path='/casuals/pants' height='275px' img='https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/25482068/2023/12/5/eed89f5a-7ec8-4d31-a923-3b413f8095541701760201439-WROGN-Men-Jeans-1361701760200963-1.jpg' />
                        </div>
                        <div className='casuals-cards'>
                            <HomePageCard width='375px' category='FORMALS' type='All' path='/formals/all' height='375px' img='https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/1849875/2023/7/14/b1dc8010-eea6-4849-a02a-85a27cd45bb21689328395526-Hancock-Men-Black-Slim-Fit-Formal-Shirt-9391689328394990-1.jpg' />
                            <HomePageCard width='375px' category='FORMALS' type='Shirts' path='/formals/shirts' height='375px' img='https://thehouseofrare.com/cdn/shop/products/IMG_0124_a9990682-c327-48cc-b502-0bd565acb5c2.jpg?v=1680172093' />
                            <HomePageCard width='375px' category='FORMALS' type='Pants' path='/formals/pants' height='375px' img='https://assets.ajio.com/medias/sys_master/root/20230613/jG5T/64887f64d55b7d0c63675e6f/-473Wx593H-469514082-grey-MODEL.jpg' />
                        </div>
                    </div>
                </div>
            )
            }
        </>

    );
}

export default Homepage;
